import { render, staticRenderFns } from "./rangliste_a4.vue?vue&type=template&id=351860d0&scoped=true"
import script from "./rangliste_a4.vue?vue&type=script&lang=js"
export * from "./rangliste_a4.vue?vue&type=script&lang=js"
import style0 from "./rangliste_a4.vue?vue&type=style&index=0&id=351860d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351860d0",
  null
  
)

export default component.exports